import React from "react";
import CommentEdit from "./CommentEdit";
import ImageWithFallback from "../../Common/ImageWithFallback";
import Currency from "../../../packs_helper/scripts/Currency";
import DateFormat from "../../../packs_helper/scripts/DateFormat";
import Stars from "../../Common/Stars";

const statusTexts = {
	approved: "Onaylandı",
	pending: "Beklemede",
	rejected: "Reddedildi",
	answer_approved: "Cevaplandı",
	answer_pending: "Beklemede",
	answer_rejected: "Reddedildi",
};

const CommentsToStoreBoxMobile = React.forwardRef((props, ref) => {
	const [boxHeight, SetBoxHeight] = React.useState(0);
	const [editModeActive, SetEditMode] = React.useState(false);
	const [answerModeActive, SetAnswerMode] = React.useState(false);
	const boxRef = React.useRef(null);
	const didMountRef = React.useRef(false);

	React.useEffect(() => {
		if (didMountRef.current) {

			const boxHeight = boxRef.current.clientHeight;
			SetBoxHeight(boxRef.current.scrollHeight);
		}
	}, [answerModeActive]);

	React.useEffect(() => {

		didMountRef.current = true;
	}, []);

	React.useImperativeHandle(ref, () => ({
		UpdateMaxHeight: () => {
			const boxHeight = boxRef.current.clientHeight;
			SetBoxHeight(boxRef.current.scrollHeight);
		},
	}));

	const ToggleWrapper = () => {
		const boxHeight = boxRef.current.clientHeight;
		if (boxHeight === 0) {
			props.GetDetail(props.id);
			SetBoxHeight(boxRef.current.scrollHeight);
			props.BoxOpen(props.id);
		} else {
			SetBoxHeight(0);
		}
	};

	const ToggleEditMode = () => {
		SetEditMode(!editModeActive);
	};

	const ToggleAnswerMode = () => {
		SetAnswerMode(!answerModeActive);
	};

	React.useEffect(() => {
		if (props.show) {
			ToggleWrapper();
		} else {
			SetBoxHeight(0);
		}
	}, [props.show]);

	return (
		<div className="user-panel-box">
			<header onClick={ToggleWrapper}>
				<StatusIcon status={props.status} />
				<strong>#{props.id}</strong>-<h2>{props.name}</h2>
				<button
					className={"btn" + (boxHeight === 0 ? "" : " rotate-ccw-180")}
				>
					<svg className="icon">
						<use xlinkHref="#gs-icon-user-panel-caret-down"></use>
					</svg>
				</button>
			</header>
			<div
				className="user-panel-box-wrapper"
				style={{ maxHeight: boxHeight }}
				ref={boxRef}
			>
				<div className="user-panel-box-body">
					<div className="comment-container">
						<div className="comment-content">
							<div className="comment-content-user">
								<h2>
									<a
										href={props.content.comment_user_code ? `/mesajlarim?active_tab=${props.content.comment_user_code}` : null}
										target="_blank"
									>
										{props.content.comment_user_name}
									</a>
								</h2>
								<strong>{DateFormat(props.content.created_at)}</strong>
								<div />
								<Stars
									value={props.content.rating}
									xlinkHref="#gs-icon-user-panel-star"
								/>
							</div>

							{props.content.comment}
						</div>
						<div className="comment-buttons">

							<a href={props.content.product_path} target="_blank" className="btn btn-dark">
								<svg className="icon">
									<use xlinkHref="#gs-icon-user-panel-tag"></use>
								</svg>
								İlana Git
							</a>

							<StatusIcon status={props.status}>
								{statusTexts[props.status]}
							</StatusIcon>

							<button
								className="btn btn-blue"
								disabled={props.content.store_comment}
								onClick={ToggleAnswerMode}
							>
								<svg className="icon">
									<use xlinkHref="#gs-icon-user-panel-edit"></use>
								</svg>
								Cevapla
							</button>
						</div>

						{answerModeActive && (
							<React.Fragment>
								<span className="comment-image">
									<ImageWithFallback
										src={`https://images.gamesatis.com/assets/avatar-set/avatar-${props.content.answer_user_avatar?props.content.answer_user_avatar:"1"}.jpg`}
									/>
								</span>
								<div className="comment-content">
									<div className="comment-content-user">
										<h2>{props.content.answer_user_name}</h2>
									</div>
									<CommentEdit
										id={props.id}
										message=""
										rating={5}
										answer={true}
									/>
								</div>
							</React.Fragment>
						)}

						{props.content.store_comment && (
							<React.Fragment>
								<div className="comment-content">
									<div className="comment-content-user">
										<h2>{props.content.answer_user_name}</h2>
									</div>
									{editModeActive ? (
										<CommentEdit
											id={props.id}
											message={props.content.store_comment}
											rating={props.content.rating}
										/>
									) : (
										props.content.store_comment
									)}
								</div>
								<div className="comment-buttons">
									<StatusIcon status={props.content.answer_status}>
										{statusTexts[props.content.answer_status]}
									</StatusIcon>

									<button
										className="btn btn-sm btn-default"
										onClick={ToggleEditMode}
										disabled={props.content.answer_status === "answer_pending"}
									>
										<svg className="icon">
											<use xlinkHref="#gs-icon-user-panel-edit"></use>
										</svg>
										Düzenle
									</button>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		</div>
	);
});

const StatusIcon = (props) => {
	if (props.status === "approved" || props.status === "answer_approved") {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-jungle"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-approved"></use>
				</svg>
				{props.children}
			</div>
		);
	} else if (
		props.status === "rejected" ||
		props.status === "answer_rejected"
	) {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-red"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-rejected"></use>
				</svg>
				{props.children}
			</div>
		);
	} else {
		return (
			<div
				className={
					(!props.children ? "status-icon" : "status-icon-with-content") +
					" status-icon-orange"
				}
			>
				<svg className="icon">
					<use xlinkHref="#gs-icon-user-panel-pending"></use>
				</svg>
				{props.children}
			</div>
		);
	}
};

export default CommentsToStoreBoxMobile;

export { StatusIcon };
